'use client';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentUser } from '@/store/reducers/appSlice';
import { useUser } from '@/contexts/UserContext';

export default function ReduxSync() {
    const dispatch = useDispatch();
    const user = useUser();

    useEffect(() => {
        if (user) {
        dispatch(setCurrentUser(user));
        }
    }, [user, dispatch]);

    return null; // No UI, just side effect
}